/* Freedom Sale — tricolour confetti, fired from both edges.
   Canvas, no dependencies. Once per session, skipped under reduced motion. */
(function () {

  function run(opts) {
    opts = opts || {};
    var COLORS = ['#FF9933', '#FFFFFF', '#138808', '#FDB813', '#000080', '#F4691E'];
    var PER  = opts.perSide || 60;
    var LIFE = opts.life    || 3800;
    /* No walls. Pieces are free to sail off the top or the sides and drift
       back in — gravity at 0.10 brings the high ones home inside the burst. */
    var G    = 0.10;

    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;width:100vw;height:100vh;' +
                       'pointer-events:none;z-index:2147483000;';
    document.body.appendChild(cv);

    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W, H;
    function size() {
      W = window.innerWidth; H = window.innerHeight;
      cv.width  = Math.floor(W * dpr);
      cv.height = Math.floor(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener('resize', size);

    var bits = [];
    /* Corner cannons fired from just INSIDE the bottom corners, angled up and
       inward. Nothing starts off-screen and nothing leaves: the edges bounce. */
    /* horizontal push scales with viewport width — a 390px phone cannot take
       the same sideways force as a 1440px desktop or pieces pile at the edge */
    var HS = Math.min(1, W / 900);
    function launch(side) {
      for (var i = 0; i < PER; i++) {
        var power = 10 + Math.random() * 5.5;
        var ang   = (52 + Math.random() * 26) * Math.PI / 180;
        bits.push({
          x: side > 0 ? 8 : W - 8,
          y: H - 8,
          vx: side * power * Math.cos(ang) * HS,
          vy: -power * Math.sin(ang),
          w: 4.5 + Math.random() * 4,
          h: 6.5 + Math.random() * 5,
          c: COLORS[(i + (side < 0 ? 3 : 0)) % COLORS.length],
          rot: Math.random() * Math.PI * 2,
          vr: -0.07 + Math.random() * 0.14,
          drag: 0.992 + Math.random() * 0.005
        });
      }
    }
    launch(1); launch(-1);

    var t0 = null, raf;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var elapsed = ts - t0, p = elapsed / LIFE;
      /* slow-motion tail: everything eases toward a near-stop as it fades out */
      var slow = p < 0.45 ? 1 : Math.max(0.14, 1 - (p - 0.45) / 0.55);
      var fade = p < 0.52 ? 1 : Math.max(0, 1 - (p - 0.52) / 0.48);

      ctx.clearRect(0, 0, cv.width, cv.height);
      for (var i = 0; i < bits.length; i++) {
        var b = bits[i];
        b.vx *= b.drag;
        b.vy  = b.vy * b.drag + G;
        b.x  += b.vx * slow;
        b.y  += b.vy * slow;
        b.rot += b.vr * slow;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(b.x, b.y);
        ctx.rotate(b.rot);
        ctx.fillStyle = b.c;
        if (b.c === '#FFFFFF') {
          ctx.strokeStyle = 'rgba(0,0,128,.32)'; ctx.lineWidth = 1;
          ctx.strokeRect(-b.w / 2, -b.h / 2, b.w, b.h);
        }
        ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h);
        ctx.restore();
      }

      if (elapsed < LIFE) raf = requestAnimationFrame(frame);
      else {
        cancelAnimationFrame(raf);
        window.removeEventListener('resize', size);
        if (cv.parentNode) cv.parentNode.removeChild(cv);
      }
    }
    raf = requestAnimationFrame(frame);
  }

  var COOLDOWN = 1200, last = 0;   /* cooldown state — do not remove */

  function reduced() {
    return !!(window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function fire(opts, force) {
    var now = Date.now();
    if (now - last < COOLDOWN) return;          /* stop rapid clicks stacking canvases */
    last = now;
    /* force comes from ?confetti=1 — it must beat the reduced-motion check,
       otherwise there is no way to test on a machine with animations off. */
    if (!force && reduced()) return;
    run(opts);
  }

  /* console helper: freedomConfettiTest() ignores every gate */
  window.freedomConfettiTest = function () { last = 0; run(); return 'fired'; };
  window.freedomConfettiState = function () {
    return { reducedMotion: reduced(),
             isCollection: /^\/collections\//.test(window.location.pathname),
             lastFired: last };
  };

  /* ── 1. collection page load ─────────────────────────────────── */
  function pageBurst() {
    var q = '';
    try { q = new URLSearchParams(window.location.search).get('confetti') || ''; } catch (e) {}
    if (q === '0') return;
    var isCollection = document.body && (
      document.body.classList.contains('template-collection') ||
      /^\/collections\//.test(window.location.pathname));
    if (!isCollection && q !== '1') return;
    if (q !== '1' && reduced()) return;

    function go() {
      if (document.visibilityState === 'hidden') {
        document.addEventListener('visibilitychange', function once() {
          if (document.visibilityState === 'visible') {
            document.removeEventListener('visibilitychange', once);
            setTimeout(function () { fire(null, q === '1'); }, 200);
          }
        });
        return;
      }
      setTimeout(function () { fire(null, q === '1'); }, 350);
    }
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  /* ── 2. add to cart, anywhere ────────────────────────────────── */
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var SMALL = { perSide: 34, life: 2800 };

  /* AJAX carts: catch the actual successful add, not just the click */
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_ADD.test(url)) {
        p.then(function (res) { if (res && res.ok) fire(SMALL); }).catch(function () {});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      this.__fsCartAdd = CART_ADD.test(url || '');
      return _open.apply(this, arguments);
    };
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__fsCartAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) fire(SMALL);
        });
      }
      return _send.apply(this, arguments);
    };
  }

  /* non-AJAX / themed buttons: fire on the click itself */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest &&
      e.target.closest('[name="add"], .btn--add-to-cart, #sticky-add-to-cart-btn, .bday-qa-btn');
    if (t) fire(SMALL);
  }, true);

  window.freedomConfetti = run;
  pageBurst();
})();
